import React, { useEffect } from "react";
import "../view/css/CalendarPage.css";
import * as firebase from 'firebase';
import {CalendarPageView} from '../view/CalendarPageView';

export const CalendarPage = () => {

    const [type_1, setType] = React.useState("");
    const [userLoaded, setUserLoaded] = React.useState(false);
    const [events, setEvents] = React.useState([]);
    const [stop_store_event, setStore] = React.useState(false);

    const firestore = firebase.firestore();
    const user = firebase.auth().currentUser;

    useEffect(() => {
        runThis();
      });

    useEffect(() => {
        async function fetchData() {
            let truthVal = await getEvents();
            setStore(truthVal);
        }
        fetchData();
    }, [userLoaded]);


    const runThis = () => {
        if (user) {
            const db = firestore.collection("Users").doc(user.email);
            const doc = db.get().then(function (doc) {
                if (doc.exists) {
                    setType(doc.data().type)
                    setUserLoaded(true);
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        }
    }

    const getEvents = async () => {
        console.log("CAME IN HERE AGAIN");
        if (user) {
            var stop_rend = false;
            const array_event = [];
            const docRef = firestore.collection("Users").doc(user.email);
            let doc = await docRef.get();
            if (doc.exists && !stop_rend) {
                const user_events = doc.data().events;
                let allPromises = await user_events.map( async (event) => {
                    let res = await event.get();
                    if(res.exists){
                    const doccer = res.data();
                    array_event.push({
                        'title': doccer.event_title,
                        'location': doccer.location,
                        'description': doccer.description,
                        'start': doccer.event_start.toDate(),
                        'end': doccer.event_end.toDate(),
                        'affiliate': doccer.username,
                        'email': doccer.Affiliate,
                        'pictures': doccer.picture,
                        'username': doccer.username,
                    })
                }
                })
                await Promise.all(allPromises)
                stop_rend = true;
                setEvents(array_event);
                return true;
            }

        }
        return false;
    }

    return (
        <CalendarPageView userLoaded={userLoaded} runThis={runThis} type_1={type_1} getEvents={getEvents} events={events}/>
    );
}